export const SOFTWARE_PRODUCTS = ['NextCut', 'NextFrame', 'NextDrill', 'NextCloud', 'NextManager'];
export const UPDATE_PRODUCTS = ['NextCut', 'NextFrame', 'NextDrill'];
export const SELF_SERVICE_PRODUCTS = ['NextCut', 'NextFrame', 'NextDrill', 'NextManager'];
/** Technical names stay exact: they are part of the licensing protocol. Only NEXT Manager has a different display name. */
export const softwareProductLabel = (product: string) => product === 'NextManager' ? 'NEXT Manager' : product;
